import { render } from "./DeleteAnnouncementDialog.vue?vue&type=template&id=17cc661e"
import script from "./DeleteAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAnnouncementDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__